import type { Video, VideoSource, AdaptiveVideoSource, VideoSourceType } from '@wix/public-schemas'
import { resolveImage, UnresolvedImage } from './image'

type UnresolvedVideoSource = Omit<VideoSource, 'types'> & {
	types: Array<Omit<VideoSourceType, 'url'>>
}
type UnresolvedAdaptiveVideoSource = Omit<AdaptiveVideoSource, 'url'>

export type UnresolvedVideo = Omit<Video, 'sources' | 'adaptiveSources' | 'poster'> & {
	sources: Array<UnresolvedVideoSource>
	adaptiveSources: Array<UnresolvedAdaptiveVideoSource>
	poster: UnresolvedImage
}

const resolveVideoUri = (videoUri: string, staticVideoUrl: string) => {
	const cleanBase = staticVideoUrl.replace(/\/$/, '')
	const cleanPath = videoUri.replace(/^\//, '')
	return `${cleanBase}/${cleanPath}`
}

export type VideoResolver = (unResolvedVideo: UnresolvedVideo, staticVideoUrl: string) => Video
export const resolveVideo: VideoResolver = (unResolvedVideo, staticVideoUrl) => {
	const sources = unResolvedVideo.sources.map((source) => {
		return {
			...source,
			types: source.types.map((type) => {
				return {
					...type,
					url: resolveVideoUri(type.uri, staticVideoUrl),
				}
			}),
		}
	})

	const adaptiveSources = unResolvedVideo.adaptiveSources.map((source) => {
		return {
			...source,
			url: resolveVideoUri(source.uri, staticVideoUrl),
		}
	})

	const poster = resolveImage(unResolvedVideo.poster)

	return { ...unResolvedVideo, sources, adaptiveSources, poster }
}
